import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React from 'react';
import { Route, Switch } from 'react-router-dom';
import SplitPane from "react-split-pane";
import '@zippytech/react-toolkit/SplitContainer/index.css';
import { Dashboard } from "./dashboard";
import { Users } from "./users";
import { Settings } from "./settings";
import { Upgrade } from "./upgrade";
import MenuItem from './../common/MenuItem';
import { dispatch } from '@rematch/core';
import './styles.css';
import { push } from "react-router-redux";
import './../common/common.css';
import { Popup } from 'semantic-ui-react';
class Account extends React.Component {

    constructor(props) {
        super(props);
        this.state = {}
    }

    componentDidMount() {
        if (!this.props.user.isVerified) {
            return dispatch(push('/updatePassword/' + this.props.user._id));
        }
        dispatch.app.baseModuleType("Account");
           // dispatch.app.setOrganisation({})

    }

    render() {
        const { selectedAccount, user, handleHelpVisibleChange } = this.props;

        /**
         * User Access control 
         * Account user can not access Settings and Users, only owner can
         */
        let isDisabled = false;
        let account = user && selectedAccount && user.accounts.filter((account, i) => { return account.id === selectedAccount._id })[0];
        if (account.role === "user") {
            isDisabled = true;
        } else if (account.role === "customerAdmin" && account.isActive === false) {
            isDisabled = true;
        }

        return (
            <SplitPane defaultSize="80px" split="vertical" allowResize={false}
                pane1Style={{ backgroundColor: "#fbfbfb" }}
                pane2Style={{ backgroundColor: "#f5f8fa" }} >
                <div className="aspenToolBar">
                    <ul className="aspenMenu topMenu">
                        <div className="vert vert_account">Account</div>
                        <MenuItem
                            to={`/app/${selectedAccount._id}/dashboard`}
                            className="Ahome"
                            name="Home" />
                        <MenuItem
                            to={isDisabled ? `#` : `/app/${selectedAccount._id}/users`}
                            className={isDisabled ? "users disable-menu" : "users"}
                            name="Users" />
                        <MenuItem
                            to={isDisabled ? `#` : `/app/${selectedAccount._id}/settings`}
                            className={isDisabled ? "settings disable-menu" : "settings"}
                            name="Settings" />
                    </ul>

                    <ul className="aspenMenu topMenu">
                        <div className="vert vert_billing">Billing</div>
                        <MenuItem
                            to={isDisabled || process.env.REACT_APP_ASPEN_SELF_URL === "https://stage.aspenify.com" ? `#` : `/app/${selectedAccount._id}/upgrade`}
                            className={isDisabled || process.env.REACT_APP_ASPEN_SELF_URL === "https://stage.aspenify.com" ? "upgrade disable-menu" : "upgrade"}
                            name="Upgrade" />
                        <MenuItem
                            to={`#`}
                            className="report disable-menu"
                            name="Report" />
                        <MenuItem
                            to={`#`}
                            className="history disable-menu "
                            name="History" />
                    </ul>
                    <ul className="aspenMenu bottomMenu top_brdr">
                        <div className="vert vert_settings_help">Help</div>
                        <li><Popup trigger={<a className="help" onClick={handleHelpVisibleChange} style={{cursor: 'pointer'}} >
                            {"Visit Aspenify Support"}
                            </a>}
                            content={"Visit Aspenify Support"}
                            position='right center'
                            inverted
                            />
                        </li>
                    </ul>

                </div>
                <div className="mainContent" >
                    <Switch>
                        <Route path={`/app/:accountId/dashboard`} component={Dashboard} />
                        <Route path={`/app/:accountId/users`} component={Users} />
                        <Route path="/app/:accountId/settings" component={Settings} />
                        <Route path="/app/:accountId/upgrade" component={Upgrade} />
                    </Switch>
                </div>
            </SplitPane>
        );
    }
}

export default Account;